import { DriverInvoiceOutput } from '@allocab/allocab-driver-shared-types';
import { useMutation } from '@tanstack/react-query';
import { saveAs } from 'file-saver';

import { constants } from '../constants';
import { getFreshTokens } from '../services/network/Api';
import { APIError } from '../services/network/types';
import { t } from '../services/translation/translation';

const downloadInvoice = async (invoice: DriverInvoiceOutput) => {
  const tokens = await getFreshTokens();

  const response = await fetch(`${constants.driverApi}/v1/invoice/${invoice.id}`, {
    method: 'GET',
    headers: {
      responseType: 'blob',
      ...(tokens ? { Authorization: `Bearer ${tokens.accessToken}` } : {}),
    },
  });

  if (!response.ok) {
    throw { type: 'api', message: t('network.server-error') } satisfies APIError;
  }

  const blob = await response.blob();

  // Download the file
  saveAs(blob, `${invoice.invoiceNumber}.pdf`);
};

export const useDownloadInvoice = () =>
  useMutation<void, unknown, DriverInvoiceOutput, DriverInvoiceOutput>({
    mutationFn: downloadInvoice,
  });
